











import Vue from "vue";
export default Vue.extend({
  props: {
    label: {
      type: String,
      default: "削除",
    },
    size: {
      type: String,
      default: "",
    },
    radius: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleOnClick() {
      if (!this.disabled) {
        this.$emit("click");
      }
    },
  },
});
